
document.addEventListener("DOMContentLoaded", function() {
  const wrapper = document.querySelector('.site-wrapper');
  const marker = document.querySelector('[data-marker]');

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        console.log('test1');
        wrapper.removeAttribute('data-scroll');
      } else {
        console.log('test2');
        wrapper.setAttribute('data-scroll', 'scrolled');
      }
    });
  }, options);

  observer.observe(marker);
});
